import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Partnerships = () => {
  const total = 13;
  const active = 1;
  const partner = "Ubitquity, Inc.";

  return (
    <section className="py-32 px-4 bg-[#030014]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-black mb-8 leading-none">
              Strategic <span className="text-gradient">Alliances.</span>
            </h2>
            <p className="text-slate-400 text-xl font-light mb-10">
              DAI KHO TOKEN is architected around a long-term network of 13 strategic partnerships. 
              We are building a foundation across infrastructure, wellness, and technology.
            </p>
            
            <div className="space-y-4 mb-12">
              <div className="flex justify-between items-end mb-2">
                <span className="text-white font-bold uppercase tracking-tighter">Current Progress</span>
                <span className="text-purple-400 font-mono text-2xl">{active} / {total}</span>
              </div>
              <div className="h-4 bg-white/5 rounded-full overflow-hidden border border-white/10 p-1">
                <motion.div 
                  initial={{ width: 0 }}
                  whileInView={{ width: `${(active/total)*100}%` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.5, ease: "easeOut" }}
                  className="h-full bg-gradient-to-r from-purple-500 via-fuchsia-500 to-cyan-400 rounded-full shadow-[0_0_15px_rgba(168,85,247,0.5)]"
                />
              </div>
            </div>

            <div className="glass-panel p-8 rounded-3xl border-l-[6px] border-l-purple-500">
              <p className="text-slate-500 text-xs font-bold uppercase tracking-widest mb-2">Lead Strategic Partner</p>
              <h4 className="text-3xl font-black text-white group-hover:text-purple-400 transition-colors">
                {partner}
              </h4>
            </div>
          </motion.div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {Array.from({ length: total }).map((_, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className={`aspect-square rounded-2xl border flex flex-col items-center justify-center gap-3 transition-all duration-500 ${
                  i < active 
                  ? 'bg-purple-500/10 border-purple-500/40 text-purple-400 shadow-[0_0_20px_rgba(168,85,247,0.1)]' 
                  : 'bg-white/5 border-white/10 text-slate-700'
                }`}
              >
                <SafeIcon name={i < active ? "Shield" : "Plus"} className="w-6 h-6" />
                <span className="text-[10px] font-bold uppercase tracking-widest">
                  {i < active ? "Active" : `Slot ${i + 1}`}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partnerships;